import queryString from 'query-string';

import { clientConfig } from '@/config/client';

const { subscriptionHost } = clientConfig;

export function getSubscriptionUrl(lang: string): string {
    return queryString.stringifyUrl({
        url: `${subscriptionHost}/my`,
        query: {
            lang,
        },
    });
}
